import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cleave from 'cleave.js/react';

import { Icon } from '../Icon';

const Field = props => {
    const { dateField, className, wrapperClassName, iconleft, iconright, hasError, size, ...otherProps } = props;
    const fieldClass = classNames(
        'field',
        'bw-1',
        'bs-solid',
        'w-100p',
        'p-2',
        'box-border',
        'br-4',
        'fs-2',
        'c-neutral-900',
        {
            'h-8': size === 'sm',
            'h-9 fs-3': size === 'md',
            'fs-3 h-10': size === 'lg',
            'bc-neutral-100 c-neutral-900': !hasError,
            'bc-error-500': hasError,
            'focus:bc-secondary-500': !hasError,
            'pl-7': iconleft,
        },
        className,
    );

    const iconLeftClassName = classNames('field__icon', {
        'field__icon-left--sm': size === 'sm',
        'field__icon-left': size === 'md',
        'field__icon-left--lg': size === 'lg',
		});
		
		const iconRightClassName = classNames('field__icon', {
			'field__icon-right--sm': size === 'sm',
			'field__icon-right': size === 'md',
			'field__icon-right--lg': size === 'lg',
	});

    const wrapperClass = classNames(wrapperClassName, 'p-relative');

    return (
        <div className={wrapperClass}>
            {iconleft && <Icon icon={iconleft} className={iconLeftClassName} />}

            {dateField ? (
                <Cleave
                    options={{ date: true, datePattern: ['d', 'm', 'Y'], delimiter: ' / ' }}
                    className={fieldClass}
                    {...otherProps}
                />
            ) : (
                <input className={fieldClass} {...otherProps} />
            )}

            {iconright && <Icon icon={iconright} className={iconRightClassName} />}
        </div>
    );
};

Field.propTypes = {
    /**
     * Class to be appended to the wrapping element
     */
    className: PropTypes.string,
    /**
     * Html type of the input text/number/email etc.
     */
    type: PropTypes.string,
    /**
     * Boolean to indicate an error state
     */
    hasError: PropTypes.bool,
    /**
     * Icon string to append to the right of the field
     */
    iconleft: PropTypes.string,
    /**
     * Icon string to append to the left of the field
     */
    iconright: PropTypes.string,
    /**
     * Classes for internal wrapper
     */
    wrapperClassName: PropTypes.string,
    /**
     * Size of the input filed
     */
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    /**
     * Date input field variant
     */
    dateField: PropTypes.bool,
};

Field.defaultProps = {
    className: '',
    type: 'text',
    iconleft: null,
    iconright: null,
    wrapperClassName: '',
    hasError: false,
    size: 'md',
    dateField: false,
};

Field.displayName = 'Field';

export default Field;
